
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import globalThis_1 from './global-this.js';

var globalThis = globalThis_1;

var navigator = globalThis.navigator;
var userAgent = navigator && navigator.userAgent;

var environmentUserAgent = userAgent ? String(userAgent) : '';

export { environmentUserAgent as default };
//# sourceMappingURL=environment-user-agent.js.map
